import React, { useState } from 'react';
import NumberDisplay from './NumberDisplay';

const LottoGenerator = () => {
  const [generatedSets, setGeneratedSets] = useState([]);
  const [selectedIncludes, setSelectedIncludes] = useState(new Set());
  const [selectedExcludes, setSelectedExcludes] = useState(new Set());
  const [error, setError] = useState('');
  const [numberOfSets, setNumberOfSets] = useState(1);

  const toggleSelection = (num) => {
    setError('');

    // If already included
    if (selectedIncludes.has(num)) {
      // Move from included to excluded
      const newIncludes = new Set(selectedIncludes);
      newIncludes.delete(num);
      setSelectedIncludes(newIncludes);

      const newExcludes = new Set(selectedExcludes);
      newExcludes.add(num);
      setSelectedExcludes(newExcludes);
    } 
    // If already excluded
    else if (selectedExcludes.has(num)) {
      // Move from excluded to none (clear)
      const newExcludes = new Set(selectedExcludes);
      newExcludes.delete(num);
      setSelectedExcludes(newExcludes);
    } 
    // If neither (not selected)
    else {
      // Add to included (if not more than 6 already)
      if (selectedIncludes.size >= 6) {
        setError('포함할 숫자는 최대 6개입니다.');
        return;
      }
      const newIncludes = new Set(selectedIncludes);
      newIncludes.add(num);
      setSelectedIncludes(newIncludes);
    }
  };


  const generateLottoNumbers = () => {
    setError('');
    const allGeneratedSets = [];

    for (let s = 0; s < numberOfSets; s++) {
      let includes = Array.from(selectedIncludes);
      let excludes = Array.from(selectedExcludes);

      // Remove any included numbers that are also in excluded numbers (should be handled by toggleSelection, but as a safeguard)
      includes = includes.filter(num => !excludes.includes(num));

      if (includes.length > 6) {
        setError('포함할 숫자는 6개 이하만 지정할 수 있습니다.');
        setGeneratedSets([]);
        return;
      }

      const finalNumbers = new Set(includes);
      const availableNumbers = Array.from({ length: 45 }, (_, i) => i + 1)
        .filter(num => !finalNumbers.has(num) && !excludes.includes(num));

      if (availableNumbers.length < (6 - finalNumbers.size)) {
        setError('제외된 숫자와 포함된 숫자의 조합으로 6개의 숫자를 생성할 수 없습니다.');
        setGeneratedSets([]);
        return;
      }

      while (finalNumbers.size < 6) {
        if (availableNumbers.length === 0) {
            setError('충분한 숫자를 생성할 수 없습니다. 포함/제외 설정을 확인해주세요.');
            setGeneratedSets([]);
            return;
        }
        const randomIndex = Math.floor(Math.random() * availableNumbers.length);
        const randomNumber = availableNumbers[randomIndex];

        finalNumbers.add(randomNumber);
        availableNumbers.splice(randomIndex, 1); // Remove from available
      }
      allGeneratedSets.push(Array.from(finalNumbers).sort((a, b) => a - b));
    }
    setGeneratedSets(allGeneratedSets);
  };

  const allNumbers = Array.from({ length: 45 }, (_, i) => i + 1);

  return (
    <div className="lotto-generator-container">
      <h2>로또 번호 생성기</h2>

      <div className="selection-grid-container">
        <h3>숫자 선택</h3>
        <p className="selection-info">
          숫자를 클릭하여 포함/제외 여부를 선택하세요:<br/>
          <span className="info-include">한 번 클릭: 포함 (파란색)</span><br/>
          <span className="info-exclude">두 번 클릭: 제외 (빨간색)</span><br/>
          <span className="info-clear">세 번 클릭: 초기화</span>
        </p>
        <div className="number-grid">
          {allNumbers.map((num) => (
            <div
              key={num}
              className={`grid-number 
                ${selectedIncludes.has(num) ? 'selected-include' : ''}
                ${selectedExcludes.has(num) ? 'selected-exclude' : ''}
              `}
              onClick={() => toggleSelection(num)}
            >
              {num}
            </div>
          ))}
        </div>
      </div> {/* End of selection-grid-container */}

      <div className="number-of-sets-section input-section">
        <label htmlFor="numberOfSets">생성할 세트 수:</label>
        <input
          id="numberOfSets"
          type="number"
          min="1"
          max="10"
          value={numberOfSets}
          onChange={(e) => setNumberOfSets(Math.max(1, parseInt(e.target.value) || 1))}
        />
      </div>
      
      {error && <p className="error-message">{error}</p>}

      <button onClick={generateLottoNumbers}>행운 번호 생성</button>

      {generatedSets.length > 0 && (
        <div className="generated-numbers-section">
          <h3>생성된 번호:</h3>
          {generatedSets.map((numbers, index) => (
            <div key={index} className="generated-set">
              <NumberDisplay numbers={numbers} title={`세트 ${index + 1}`} />
            </div>
          ))}
          <button 
            className="copy-all-button" 
            onClick={() => {
              const allNumbersText = generatedSets.map((set, index) => 
                `세트 ${index + 1}: ${set.join(', ')}`
              ).join(' | ');
              navigator.clipboard.writeText(allNumbersText);
            }}
          >
            모든 번호 복사
          </button>
        </div>
      )}

      <p className="disclaimer">
        * 본 번호는 무작위로 생성되며, 당첨을 보장하지 않습니다. 재미로만 이용해주세요.
      </p>
    </div>
  );
};

export default LottoGenerator;